import Header from './Header';
import Footer from './Footer';

export default function Layout({ children }: any) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <main style={{ padding: '40px 20px', flex: 1 }}>
        {children}
      </main>
      <Footer />
    </div>
  );
}